import { useQuery } from "@tanstack/react-query";
import { useParams } from "react-router-dom";
import getCampaignDeploy from "api/campaign/getCampaignDeploy";
import { URL_KEYS } from "constants/dashboard";
import usePaginationSortSearchQueryParams from "hooks/usePaginationSortSearchQueryParams";
import useRouterSearchParams from "hooks/useRouterSearchParams";
import { phaseIdWithQueryParams } from "queryKeys/phase";
import select from "./select";

/* IMPORTANT: hook attached to react-router. hook parses URL. */
export default function useSinglePhase(options) {
  const { id } = useParams();
  const [searchParams] = useRouterSearchParams();
  const queryParams = usePaginationSortSearchQueryParams();
  const action = searchParams.get(URL_KEYS.action) ?? undefined;
  const assignedTo = searchParams.get(URL_KEYS.assignedTo) ?? undefined;

  return useQuery({
    queryKey: phaseIdWithQueryParams({ id, queryParams: { ...queryParams, action, assignedTo } }),
    queryFn: getCampaignDeploy,
    select,
    ...options,
  });
}
